<template>
  <div class="ui right aligned container">
    <button @click="addMessage" class="ui primary icon button">Add</button>
    <button @click="refresh" class="ui primary icon button"><i class="sync icon"></i></button>

    <vuetable ref="vuetable"
              api-url="/notifications"
              :sort-order="sortOrder"
              :fields="fields"
              @vuetable:pagination-data="onPaginationData"
    >
      <template scope="props" slot="actions">
        <i @click="editMessage(props.rowData)" class="edit link icon"></i>
        <i @click="deleteMessage(props.rowData)" class="red trash alternate outline link icon"></i>
      </template>
    </vuetable>
    <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage"></vuetable-pagination>

    <Modal v-model="modal">
      <template slot="title">
        {{title}}
      </template>
      <form class="ui form">
        <div class="required field">
          <label>标题</label>
          <input name="title" placeholder="标题" type="text" v-model="message.title">
        </div>
        <div class="required field">
          <label>内容</label>
          <input name="content" placeholder="内容" type="text" v-model="message.content">
        </div>
        <div class="required field">
          <label>URL</label>
          <input name="url" placeholder="URL" type="url" v-model="message.url">
        </div>
        <div class="required field">
          <label>时间范围</label>
          <date-picker format="YYYY-MM-DD HH:mm:ss" range type="datetime" v-model="message.range"></date-picker>
        </div>
      </form>
      <template slot="actions">
          <div @click="onCancel" class="ui cancel button">取消</div>
          <div @click="onSubmit" class="ui positive button">提交</div>
      </template>
    </Modal>

  </div>
</template>

<script>
  import axios from 'axios';
  import DatePicker from 'vue2-datepicker';
  import Vuetable from '../../table/Vuetable.vue';
  import VuetablePagination from '../../table/VuetablePagination.vue';
  import Modal from '../../components/Modal';

  export default {
    name: 'NotificationAdmin',
    components: {
      Vuetable,
      VuetablePagination,
      DatePicker,
      Modal,
    },
    data() {
      return {
        modal: false,
        message: {
          title: '',
          content: '',
          url: '',
          startTime: '',
          endTime: '',
        },
        sortOrder: [
          {
            field: 'id',
            direction: 'desc'
          }
        ],
        title: '添加',
        fields: [
          {name: 'id', title: 'ID'},
          {name: 'title', title: '标题'},
          {name: 'content', title: '内容'},
          {name: 'url', title: 'URL', callback: 'link'},
          {name: 'startTime', title: '开始时间', callback: 'date'},
          {name: 'endTime', title: '结束时间', callback: 'date'},
          {name: '__slot:actions', title: ''}
        ],
      };
    },
    methods: {
      onPaginationData(paginationData) {
        this.$refs.pagination.setPaginationData(paginationData);
      },
      onChangePage (page) {
        this.$refs.vuetable.changePage(page)
      },
      refresh: function () {
        this.$refs.vuetable.reload();
      },
      link: function (value) {
        return `<a href="${value}" target="_blank">${value}</a>`;
      },
      date: function(value) {
        return new Date(value).toLocaleString();
      },
      editMessage(message) {
        this.message = {
          id: message.id,
          title: message.title,
          content: message.content,
          url: message.url,
          range: [message.startTime, message.endTime],
        };
        this.title = '编辑';
        this.modal = true;
      },
      deleteMessage(message) {
        axios.delete('/notifications/' + message.id).then(() => {
          this.refresh();
        }).catch((error) => {
          console.log(error);
        });
      },
      addMessage() {
        this.title = '添加';
        this.modal = true;
      },
      onCancel() {
        if (this.message.id) {
          this.message = {};
        }
        this.modal = false;
      },
      onSubmit() {
        const range = this.message.range;
        if (!this.message.title || !this.message.content || !this.message.url || !range) {
          return;
        }
        delete this.message['range'];
        this.message.startTime = new Date(range[0]);
        this.message.endTime = new Date(range[1]);
        let api = '/notifications';
        if (this.message.id) {
          api = '/notifications/' + this.message.id;
        }
        axios.post(api, this.message).then(() => {
          this.message = {};
          this.modal = false;
          this.refresh();
        }).catch((error) => {
          console.log(error);
        });
      },
    }
  };
</script>

<style scoped>

</style>
